import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Register } from './model/register-user-model';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  backendUrl: string;
  constructor(private http: HttpClient) {
    this.backendUrl = environment.backendURLV2;
  }
  registerUser(
    mail: string,
    password: string,
    newsletter: boolean,
    commercial: boolean,
    isocode: string,
    token: string | null
  ) {
    let registerDto: Register = Register.new();

    if (commercial) {
      registerDto = new Register(
        mail,
        password,
        newsletter,
        isocode.split('-')[1],
        isocode.split('-')[0],
        "Commercial",
        token
      );
    } else {
      registerDto = new Register(
        mail,
        password,
        newsletter,
        isocode.split('-')[1],
        isocode.split('-')[0],
        "Private",
        token
      );
    }
    return this.http.post(this.backendUrl + '/User', registerDto);
  }
}
